const THREAD_LIST_SCOPE_VALUES = new Set(['main', 'schedules', 'triggers', 'workflows']);

const normalizeThreadListScope = (value, fallback = 'main') => {
  const normalized = String(value || '')
    .trim()
    .toLowerCase();

  if (THREAD_LIST_SCOPE_VALUES.has(normalized)) {
    return normalized;
  }

  return fallback;
};

export default normalizeThreadListScope;
